<template>
  <div>
    <a-modal
      class="market-modal"
      v-model="madalVisible"
      :title="null"
      :footer="null"
      :width="600"
      @ok="handleOk">
      <template #closeIcon>
        <img src="@/assets/svg/close.svg">
      </template>
      <p class="market-title">
        <img class="title-icon" :src="currentCoinUrl" alt="">
        <!-- <img v-if="currentCoinUrl" class="title-icon" :src="currentCoinUrl" alt=""> -->
        <!-- <img v-else class="title-icon" src="@/assets/svg/coin.svg" alt=""> -->
        <span class="title-text">{{coinSymbolIntroduce.shortName  || '-'}}</span>
      </p>
      <p class="market-content">{{ coinSymbolIntroduce.introduction  || '-' }}</p>
      <ul class="market-list">
        <li v-if="coinSymbolIntroduce.officialUrl">
          <a :href="coinSymbolIntroduce.officialUrl" target="_blank">
            <img src="@/assets/svg/official.svg"/>{{ $t('trade.currencyNotesModal.officialWebsite') }}
          </a>
        </li>
        <li v-if="coinSymbolIntroduce.blockchainUrl">
          <a
            :href="coinSymbolIntroduce.blockchainUrl"
            target="_blank"
            class="link-label"
          ><img src="@/assets/svg/block.svg"/>{{ $t('trade.currencyNotesModal.blockQuery') }}</a>
        </li>
        <!-- <li><img src="@/assets/svg/github.svg"/>GitHub</li>
        <li><img src="@/assets/svg/twitter.svg"/>Twitter</li>
        <li><img src="@/assets/svg/twitter.svg"/>Twitter</li>
        <li><img src="@/assets/svg/twitter.svg"/>Twitter</li> -->
      </ul>
      <div class="market-record">
        <p class="market-record-item" v-for="(item, index) in recordList" :key="index">
          <span class="market-record-label">{{ item.label }}</span>
          <span class="market-record-value">{{ coinSymbolIntroduce[item.value] || '-' }}</span>
        </p>
      </div>
      <div class="market-button" @click="bandLink(coinName)">
        <a-button type="primary">{{ $t("market.text2") }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { myStorage } from '@/utilsui';

export default {
  name: 'MarketModal',
  data() {
    return {
      madalVisible: false,
      coinName: '',
      recordList: [
        {
          label: this.$t('trade.currencyNotesModal.issueTime'),
          value: 'publishTimeStr',
        },
        {
          label: this.$t('trade.currencyNotesModal.totalIssueAmount'),
          value: 'publishAmount',
        },
        {
          label: this.$t('trade.currencyNotesModal.totalCirculation'),
          value: 'currencyAmount',
        },
      ],
    };
  },
  computed: {
    symbolName() {
      const symbolName = this.coinName.split('/')[0];
      return symbolName;
    },

    coinSymbolIntroduce() {
      let currentCoinInfo = {};
      const { coinSymbolIntroduce } = this.$store.state.baseData;
      coinSymbolIntroduce.forEach((el) => {
        if (el.coinSymbol === this.symbolName) {
          currentCoinInfo = el;
        }
      });

      return currentCoinInfo;
    },

    market() {
      return this.$store.state.baseData.market;
    },

    currentCoinUrl() {
      const coinList = this.market && this.market.coinList;
      if (coinList && coinList[this.symbolName]) {
        return coinList[this.symbolName].icon;
      }
      return '';
    },
  },
  methods: {
    show(coinName) {
      this.coinName = coinName;
      this.madalVisible = true;
    },
    bandLink(data) {
      if (data) {
        myStorage.set('sSymbolName', data);
        myStorage.set('markTitle', data.split('/')[1]);
        this.$router.push(`/trade/${data.replace('/', '_')}`);
      }
    },
    handleOk() {

    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
.market-title {
  margin-top: 22px;
  display: flex;
  align-items: center;
  color: $light-ft;
  margin-bottom: 16px;
  .title-text {
    font-size: 24px;
    line-height: 24px;
  }
  .title-icon {
    width: 36px;
    height: 36px;
    margin-right: 16px;
  }
}
.market-content {
  font-size: 12px;
  line-height: 24px;
  color: $light-ft;
  margin-bottom: 16px;
  max-height: 288px;
  overflow-y: auto;
}
.market-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  li {
    margin-right: 24px;
    font-size: 12px;
    line-height: 14px;
    color: $gray;
    display: flex;
    align-items: center;
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
}
.market-record {
  margin-top: 24px;
  background: $light-bg;
  border-radius: 4px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  &-value, &-label {
    display: block;
    font-size: 14px;
    line-height: 16px;
  }
  &-label {
    color: $gray;
    margin-bottom: 8px;
  }
  &-value {
    color: $light-ft;
  }
  &-item:last-child {
    text-align: right;
  }
}
.market-button {
  margin-top: 24px;
  margin-bottom: 2px;
  text-align: right;
  ::v-deep .ant-btn {
    background-color: $blue;
    color: $white;
    height: 36px;
    border: none;
    &:hover {
      background-color: $blue;
      color: $white;
    }
  }
}
.dark {
  .market-modal {
    ::v-deep .ant-modal-content  {
      background-color: $dark-bg;
    }
    .title-text, .market-content {
      color: $white;
    }
    .market-record {
      background-color: $dark-bg-second;
      &-value {
        color: $white;
      }
    }
  }
}
</style>
